<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 18 18"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M7.387 5.383h4.374l2.27-3.595a.778.778 0 0 0-.303-.057h-8.31c-.11 0-.214.02-.3.057l2.269 3.595zm.295 3.71l-4.148-6.57c-.537-.849-.128-1.893.913-2.33.3-.127.633-.193.971-.193h8.31c1.171 0 2.12.775 2.12 1.73 0 .277-.08.548-.235.794l-4.155 6.58c-.033.053-.07.103-.108.152l4.003 5.916c.566.836.194 1.89-.83 2.351a2.504 2.504 0 0 1-1.026.216h-8.08c-1.17 0-2.12-.775-2.12-1.73 0-.293.091-.581.265-.837l4.04-5.97c.025-.037.051-.074.08-.109zM4.997 1.6c.066.105.018.23.12.188l-.12-.188z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
